import { MapPin, Clock, Mail, Phone, Instagram } from "lucide-react";
import { useLanguage } from "@/i18n";

export const LocationSection = ({ settings }) => {
  const { t, pick } = useLanguage();
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(settings.address || "")}`;
  return (
    <section id="location" className="px-4 sm:px-8 lg:px-16 py-20 sm:py-28 border-t border-white/10" data-testid="location-hours-section">
      <p className="font-mono2 text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-3">06 —</p>
      <h2 className="font-display uppercase text-5xl sm:text-7xl tracking-wide mb-12">{t("location_title")}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        <div className="bg-[#0A0A0B] p-8">
          <MapPin size={18} className="text-[#E63946] mb-4" />
          <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-2">{t("location_title")}</p>
          <p className="text-lg" data-testid="location-address">{settings.address}</p>
          {settings.address && (
            <a href={mapsUrl} target="_blank" rel="noreferrer" data-testid="location-maps-link"
              className="inline-block mt-4 font-mono2 text-[10px] tracking-[0.25em] uppercase text-zinc-400 hover:text-white border-b border-white/20 pb-1 transition-colors">
              Google Maps →
            </a>
          )}
        </div>
        <div className="bg-[#0A0A0B] p-8">
          <Clock size={18} className="text-[#E63946] mb-4" />
          <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-2">{t("hours_title")}</p>
          <p className="text-lg" data-testid="location-hours">{pick(settings.hours)}</p>
        </div>
        <div className="bg-[#0A0A0B] p-8 flex flex-col gap-3">
          <Mail size={18} className="text-[#E63946] mb-1" />
          <p className="font-mono2 text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-1">{t("contact_title")}</p>
          {settings.email && <a href={`mailto:${settings.email}`} data-testid="contact-email" className="text-lg hover:text-[#E63946] transition-colors">{settings.email}</a>}
          {settings.phone && <a href={`tel:${settings.phone.replace(/[^+\d]/g, "")}`} data-testid="contact-phone" className="text-lg hover:text-[#E63946] transition-colors flex items-center gap-2"><Phone size={14} />{settings.phone}</a>}
          {settings.instagram && <a href={settings.instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram" className="text-lg hover:text-[#E63946] transition-colors flex items-center gap-2"><Instagram size={14} />Instagram</a>}
        </div>
      </div>
    </section>
  );
};
